import { StoryblokStory } from 'storyblok-generate-ts';
import { ArticleStoryblok, FeaturedArticleStoryblok } from '../storyblok/storyblok-types';

const MockArticle: ArticleStoryblok = {
    created_at: '2023-10-03T14:08:57.942Z',
    _uid: 'c4fe687e-fd78-4cdf-ab09-a88e9cdcfade',
    closeButton: 'close',
    backButton: 'back',
    seoMetatags: {
        _uid: undefined,
        title: undefined,
        plugin: undefined,
        og_image: undefined,
        og_title: undefined,
        description: undefined,
        twitter_image: undefined,
        twitter_title: undefined,
        og_description: undefined,
        twitter_description: undefined,
    },
    articleBy: 'Jakob Kaya',
    component: 'article',
    title: '',
    customTitle: '',
    intro: { type: 'mock' },
    author: '',
    mainImage: {
        alt: 'fallback',
        id: 123456,
        filename: 'img.png',
        name: 'my-image',
    },
    release: '',
};
const MockStory: StoryblokStory<ArticleStoryblok> = {
    name: 'Geringe Kosten, grosser Impact: Der “Dog Mode” bei Tesla',
    created_at: '2023-10-03T14:08:57.942Z',
    published_at: '2023-10-06T14:03:29.574Z',
    id: 381777865,
    uuid: 'c4fe687e-fd78-4cdf-ab09-a88e9cdcfade',
    content: MockArticle,
    slug: 'dog-mode-tesla',
    full_slug: 'blog/dog-mode-tesla',
    sort_by_date: null,
    position: -70,
    tag_list: [],
    is_startpage: false,
    parent_id: 261149612,
    meta_data: null,
    group_id: '3fb9c141-5cbb-4512-8dda-5d9300665256',
    first_published_at: '2023-10-06T14:03:29.574Z',
    release_id: null,
    lang: 'default',
    path: '',
    alternates: [],
    default_full_slug: 'blog/dog-mode-tesla',
    translated_slugs: [],
    _stopResolving: true,
};
export const MockFeaturedArticle: FeaturedArticleStoryblok = {
    articleItems: [MockStory],
    buttonText: '',
    _uid: '',
    component: 'featuredArticle',
};
